import instance from './Request';

export const getPuntosVenta = async() => {
  const request = await instance();
  let data = await request
    .get(`/finder`)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const getTypes = async () => {
  const request = await instance();
  let data = await request
    .get('/finder/list-types')
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const changeCategoryActive = async category => {
  const request = await instance();
  let data = await request
    .post('/finder/types/activate', {type:category})
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const newCategory = async dataCategoria => {
  const request = await instance();
  let data = await request
    .post('/finder/types', dataCategoria)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const newPuntoVenta = async puntoVenta => {
  const request = await instance();
  console.log("data",JSON.stringify(puntoVenta))
  let data = await request
    .post('/finder', puntoVenta)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const editPuntoVenta = async (id, puntoVenta) => {
  const request = await instance();
  let data = await request
    .put(`/finder/${id}`, puntoVenta)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const editCategory = async (id, dataCategoria) => {
  const request = await instance();
  let data = await request
    .put(`/finder/types/${id}`, dataCategoria)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const deletePuntoVenta = async id => {
  const request = await instance();
  let data = await request
    .delete(`/finder/${id}`)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const deleteCategory = async id => {
  const request = await instance();
  let data = await request
    .delete(`/finder/types/${id}`)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};
